<!--

Example:

<v-dialog v-model="showDianlog" max-width="850px" scrollable>
    <v-card>
        <v-card-title>
            Boka massage
        </v-card-title>
        <v-card-text style="overflow-y: auto" class="z-no-x-scroll">
            <stepper-content v-model="currentStep" :steps="steps" class="fill-width" style="height: 70vh">
                <template #time="{step}">
                    Välj tid.. {{step}}
                </template>
                <template #questions>
                    Frågor
                </template>
                <template #products>
                    Produkter
                    <div style="height: 2000px;background: lightgray" />
                </template>
                <template #checkout>
                    Betala
                </template>
            </stepper-content>
        </v-card-text>

        <v-card-actions>
            <stepper-controller v-model="currentStep" :steps="steps" />
        </v-card-actions>
    </v-card>
</v-dialog>

-->

<template>
    <div style="background-color:white" class="pt-2 fill-width" ref="stepper" v-if="show">
        <div class="d-flex justify-space-between" :class="{'mx-2': fixed}" v-if="showTitle">
            <div v-for="(step,index) in steps" :key="index" style="display: contents">
                <div class="d-flex flex-column align-center z-clickable" :class="{'z-clickable': step.complete && index < currentStep && !disabled}" @click="stepClicked(step)" v-ripple="step.complete && index < currentStep && !disabled">
                    <v-avatar :color="getColor(step).name" :size="circleSize" >
                        <span class="white--text" v-text="index+1" />
                    </v-avatar>
                    <div v-text="step.title" :style="{'color': getColor(step).hex}"/>
                </div>
                <hr class="v-divider theme--light" :style="{'margin-top': (circleSize/2) + 'px'}" v-if="index < steps.length-1"/>
            </div>
        </div>
        <div class="mt-2 d-flex" v-if="showExtraButton">
            <v-btn color="primary" outlined block :disabled="extraButtonDisabled" class="zoezi-button-thin" :class="extraButtonDisabled ? 'z-disable-clicks' : null"  @click="extraButtonClicked">{{extraButtonLabel}}</v-btn>
        </div>
        <div class="mt-2 d-flex" :class="blockButtons ? '' : 'justify-end'">
            <div :style="blockButtons ? 'width: 50%' : ''">
                <v-btn color="grey-lighten-1" @click="backClicked" :block="blockButtons" :disabled="disabled" :style="smallButtons ? 'height: 32px; font-size: 0.8rem' : ''" class="zoezi-button-thin mr-1">{{ currentStep == 0 && cancelTitle ? cancelTitle : $translate(currentStep == 0 ? 'Cancel' : 'Go back') }}</v-btn>
            </div>
            <div :style="blockButtons ? 'width: 50%' : ''">
                <v-btn :color="buttonDisabled ? 'error' : (currentStepItemSafe.nextColor || 'primary')" :block="blockButtons" @click="nextClicked" :dark="!buttonDisabled && currentStepItemSafe.nextDark" :loading="currentStepItemSafe.nextLoading" :style="smallButtons ? 'height: 32px; font-size: 0.8rem' : ''" class="zoezi-button-thin ml-1" :class="buttonDisabled ? 'z-disable-clicks' : null" :outlined="buttonDisabled">{{currentStepItemSafe.nextTitle || $translate('Continue')}}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-stepper',

    zoezi: {
        title: 'Stepper',
        internal: true
    },

    props: {
        value: {
        },
        steps: {
            type: Array
        },
        fixed: {
            type: Boolean,
            default: false
        },
        successColor: {
            type: String,
            default: 'success'
        },
        nextStepColor: {
            type: String,
            default: 'grey lighten-1'
        },
        circleSize: {
            type: Number,
            default: 20
        },
        show: {
            type: Boolean,
            default: true
        },
        animationDuration: {
            type: Number,
            default: 700
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        cancelTitle: {
            type: String,
            default: null
        },
        blockButtons: {
            type: Boolean,
            default: true
        },
        smallButtons: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.setStep(this.currentStep, value);
            }
        },
        currentStep() {
            this.$emit('input', this.currentStep);
        }
    },
    data: () => ({
        currentStep: 0
    }),
    computed: {
        currentStepItemSafe() {
            if (!this.steps || this.currentStep < 0 || this.currentStep >= this.steps.length) {
                return {}
            }
            return this.steps[this.currentStep];
        },
        buttonDisabled() {
            return !this.currentStepItemSafe.complete || this.disabled;
        },
        showExtraButton() {
            return !!this.currentStepItemSafe.extraButton;
        },
        extraButtonLabel() {
            return this.currentStepItemSafe.extraButton?.label;
        },
        extraButtonDisabled() {
            return this.disabled || !!this.currentStepItemSafe.extraButton?.disabled;
        }
    },
    methods: {
        setStep(from, to) {
            this.currentStep = to;
            if (from != to) {
                this.$emit('beforeLeave', from, to)
            }
        },
        backClicked() {
            if (this.currentStep > 0) {
                this.setStep(this.currentStep, this.currentStep-1);
            } else {
                this.$emit('cancel');
            }
        },
        nextClicked() {
            if (this.steps[this.currentStep].nextClicked) {
                this.steps[this.currentStep].nextClicked();
                return;
            }

            if (this.currentStep < this.steps.length -1) {
                this.setStep(this.currentStep, this.currentStep+1);
            }
        },
        extraButtonClicked() {
            this.currentStepItemSafe.extraButton?.clicked?.();
        },
        stepClicked(step) {
            let next = this.steps.indexOf(step);
            if (step.complete && next < this.currentStep && !this.disabled) {
                this.setStep(this.currentStep, next);
            }
        },
        getColor(step) {
            let index = this.steps.indexOf(step);
            let color = {};
            if (index > this.currentStep) {
                color.name = this.nextStepColor;
            } else if (index == this.currentStep) {
                color.name = 'primary';
            } else {
                color.name = this.successColor;
            }
            color.hex = this.$root.colorToHex(color.name);

            return color;
        }
    }
}
</script>
